export const MENA_COUNTRIES = [
  "AF",
  "AE",
  "BH",
  "DJ",
  "DZ",
  "EG",
  "IR",
  "IQ",
  "IL",
  "JO",
  "KW",
  "LB",
  "LY",
  "MA",
  "MT",
  "OM",
  "PK",
  "QA",
  "SA",
  "SY",
  "TN",
  "YE",
];
